import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Context as StoreUserContext } from '../../../providers/StoreUserContextProvider';
import { Context as HelperContext } from '../../../providers/HelperContextProvider';
import AppStack from '../../common/AppStack';
import AppTitle from '../../common/AppTitle';
import WsProductGrid from './webstore/sections/productGrid/WsProductGrid';

const config = {
  productsPerPage: 8,
  desktopColumnCount: 4,
  mobileColumnCount: 1,
  filterEnabled: 'false',
  sortEnabled: 'false'
};

const blocks = [];

const WebstoreProductsGridPage = ({
  ecomStore,
  regAssociation,
  themeConfig,
  mediaQueries,
  analyticCta,
  colorSchemes
}) => {
  const { search } = useLocation();
  const { state } = useContext(StoreUserContext);
  const { toggleWebstoreProductsShowcaseModal } = useContext(HelperContext);

  const ecomStoreCollection = state.ecomStoreCollectionHistory.value.find(
    (c) => c.fkEcomStore === ecomStore?.pkEcomStore
  );

  return (
    <AppStack style={{ gap: 20 }}>
      <AppTitle>Featured products</AppTitle>

      <WsProductGrid
        analyticCta={analyticCta}
        blocks={blocks}
        colorSchemes={colorSchemes}
        config={config}
        mediaQueries={mediaQueries}
        onNavigate={(e, ecomStoreProduct) => {
          e.preventDefault();
          e.stopPropagation();

          toggleWebstoreProductsShowcaseModal({
            isOpen: true,
            ecomStoreProduct,
            analyticCta
          });
        }}
        pkEcomStore={ecomStore?.pkEcomStore}
        pkEcomStoreCollection={ecomStoreCollection?.pkEcomStoreCollection}
        pkRegAssociation={regAssociation?.pkRegAssociation}
        search={search}
        themeConfig={themeConfig}
      />
    </AppStack>
  );
};

WebstoreProductsGridPage.propTypes = {
  analyticCta: PropTypes.string,
  colorSchemes: PropTypes.array,
  ecomStore: PropTypes.object,
  mediaQueries: PropTypes.object,
  regAssociation: PropTypes.object,
  themeConfig: PropTypes.object
};

export default WebstoreProductsGridPage;
